import clsx from 'clsx';
import * as React from 'react';

type Props = {
  on: boolean;
  onClick: React.ReactEventHandler;
  onIcon: any;
  offIcon: any;
  className: string;
};
const IconSwitcher = ({
  on,
  onClick,
  onIcon,
  offIcon,
  className,
  ...props
}: Props) =>
  React.cloneElement(on ? onIcon : offIcon, {
    className: clsx(className, 'icon_switcher', {
      selected: on,
    }),
    onClick,
    ...props,
  });

export default IconSwitcher;
